import { MODAL_SHOW_IRREGULAR, STEPPER_MODAL_SHOW_OFF, ATTACHMENT_MODAL_SHOW_OFF, TRACEABILITY_MAP_MODAL_SHOW_OFF, PRINTER_PLUGIN_MODAL_SHOW_OFF } from '../types';

const state = {
  irregularModal: false,
  isStepperModalVisible: false,
  isDocumentUploadModalVisible: false,
  isTraceabilityMapModalVisible: false,
  isNewDocModalOpen: false,
  isPrinterPluginModalVisible: false,
};

const mutations = {
  [MODAL_SHOW_IRREGULAR](state, value) {
    state.irregularModal = value;
  },
  [STEPPER_MODAL_SHOW_OFF](state, value) {
    state.isStepperModalVisible = value;
  },
  [ATTACHMENT_MODAL_SHOW_OFF](state, value) {
    state.isNewDocModalOpen = value;
    state.isDocumentUploadModalVisible = value;
  },
  [TRACEABILITY_MAP_MODAL_SHOW_OFF](state, value) {
    state.isTraceabilityMapModalVisible = value;
  },
  [PRINTER_PLUGIN_MODAL_SHOW_OFF](state, value) {
    state.isPrinterPluginModalVisible = value;
  },
};

const getters = {
  isIrregularVisible: state => {
    return state.irregularModal;
  },
  isStepperModalVisible: state => {
    return state.isStepperModalVisible;
  },
  isDocumentUploadModalVisible: state => {
    return state.isDocumentUploadModalVisible;
  },
  isTraceabilityMapModalVisible: state => {
    return state.isTraceabilityMapModalVisible;
  },
  isNewDocModalOpen: state => {
    return state.isNewDocModalOpen;
  },
  isPrinterPluginModalVisible: state => {
    return state.isPrinterPluginModalVisible;
  },
};

const actions = {
  showIrregularModal: function ({ commit }, value) {
    commit(MODAL_SHOW_IRREGULAR, value);
  },
  setStepperModalVisible: function ({ commit }, value) {
    commit(STEPPER_MODAL_SHOW_OFF, value);
  },
  setDocumentUploadModalVisible: function ({ commit }, value) {
    commit(ATTACHMENT_MODAL_SHOW_OFF, value);
  },
  setTraceabilityMapModalVisible: function ({ commit }, value) {
    commit(TRACEABILITY_MAP_MODAL_SHOW_OFF, value);
  },
  setPrinterPluginModalVisible: function ({ commit }, value) {
    commit(PRINTER_PLUGIN_MODAL_SHOW_OFF, value);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
export { mutations, actions, getters };
